<template>
  <div>
    <div class="content">
      <div class="content-main">
        <p class="content-title">评价短信<un-lock/><page-desc/></p>
        <div class="content-input">
          <div class="content-input-left">
            <div class="content-input-item">
              <label>所属门店</label>
              <el-select v-model="shopId" placeholder="Select" class="select-item">
                <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>

            <div class="content-input-item">
              <label>短信类型</label>
              <el-select v-model="type" placeholder="Select" class="select-item">
                <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>

            <div class="content-input-item">
              <DatePickerRange title="时间" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
            </div>



            <div class="content-input-item">
              <label>处理状态</label>
              <el-select v-model="state" placeholder="Select" class="select-item">
                <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>

            <div class="content-input-item">
              <label>查看状态</label>
              <el-select v-model="visitState" placeholder="Select" class="select-item">
                <el-option v-for="item in visitStateArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>

            <div class="content-input-item">
              <label>满意度</label>
              <el-select v-model="satisfaction" placeholder="Select" class="select-item">
                <el-option v-for="item in satisfactionArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>


            <div class="content-input-item">
              <!--              <label>客户搜索</label>-->
              <SearchComponents width="7.2em" :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
              <el-checkbox v-model="limitState" style="margin-left: 8px;"><span style="white-space: nowrap">有限制</span></el-checkbox>
            </div>

          </div>
          <div class="content-input-right">
            <div class="content-input-btn">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
            </div>
            <div class="content-input-btn">
              <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
            </div>
          </div>
        </div>
      </div>
      <div class="content-main">
        <!--        <p class="content-title" style="padding-bottom: 16px;">用户权限</p>-->
        <div class="content-button">
          <div>
            <el-button type="primary" @click="batchUpdateState" v-loading="batchLoading" size="default">批量已处理</el-button>
            <el-button type="warning" @click="updatePhone" size="default">通知短信</el-button>
          </div>
          <div style="display: flex;align-items: center;">
            <div style="margin-right: 24px;">
              预约短信：<el-switch :active-value="1" :inactive-value="0" v-model="preBookOff" @change="offChange(1)"/>
            </div>
            <div>
              消费短信：<el-switch :active-value="1" :inactive-value="0"  v-model="consumeOff" @change="offChange(2)"/>
            </div>
            <BtnGroup :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
          </div>

        </div>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; "
              v-loading="listLoading"
              @cell-click="toggleSelection"
              @selection-change="selsChange"
              @header-click="selsAll"
              size="default"
              border
          >
            <el-table-column type="selection" width="55" align="center" class-name="cursor"/>
            <el-table-column property="updateTime" label="时间" v-if="checkColList.indexOf('时间') > -1" />
            <el-table-column property="shopName" label="所属门店" v-if="checkColList.indexOf('所属门店') > -1" />
            <el-table-column property="" label="短信类型" v-if="checkColList.indexOf('短信类型') > -1" >
              <template #default="scope">
                {{scope.row.type ==1?'预约短信':scope.row.type ==2?'消费短信':scope.row.type ==3?'邀请评价短信':''}}
              </template>
            </el-table-column>
            <el-table-column property="" label="客户信息" v-if="checkColList.indexOf('客户信息') > -1" width="200">
              <template #default="scope">
                <p @click="userInfoDialog(scope.row.userId)">主人：<span style="color: #3a8ee6; cursor: pointer">{{scope.row.userName}}</span></p>
                <p>性别：{{scope.row.sex ==1?'男':scope.row.sex ==2?'女':'未知'}}</p>
                <p>手机：{{scope.row.phone}}</p>
                <p>门店：{{scope.row.userShopName}}</p>
                <p>主人ID：{{scope.row.uid}}</p>
              </template>
            </el-table-column>
            <el-table-column property="projectName" label="猫咪信息" v-if="checkColList.indexOf('猫咪信息') > -1" class-name="cursor" width="300">
              <template #default="scope">
                <div style="margin: 8px 0;" v-for="(item, index) of scope.row.petList" :key="item.id">
                  <p>{{item.petBreedColorName}}{{item.woolState == 1?'短毛':item.woolState == 2?'长毛':''}}（{{item.name}}）<span v-if="item.petAgeMonth">{{item.petAgeMonth.age}}岁{{item.petAgeMonth.month}}个月</span>（{{item.sex == 1?'弟弟':item.sex == 2?'妹妹':'未知'}}）{{item.neuteringState == 1?'已绝育':item.neuteringState == 2?'未绝育':'未知'}}</p>
                  <p v-if="item.exemptionDesc" style="color: red; font-size: 12px">*{{item.exemptionDesc}}</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column property="numberNo" label="消费单号" v-if="checkColList.indexOf('消费单号') > -1" />
            <el-table-column property="" label="查看状态" v-if="checkColList.indexOf('查看状态') > -1" >
              <template #default="scope">
                <p>{{scope.row.visitTime?'已查看':'未查看'}}</p>
                <p v-if="scope.row.visitTime">{{scope.row.visitTime}}</p>
              </template>
            </el-table-column>
            <el-table-column property="" label="满意度" v-if="checkColList.indexOf('满意度') > -1" >
              <template #default="scope">
                {{scope.row.satisfaction == 1?'不满意':scope.row.satisfaction == 2?'一般':scope.row.satisfaction == 3?'满意':''}}
              </template>
            </el-table-column>
            <el-table-column property="" label="处理状态" v-if="checkColList.indexOf('处理状态') > -1" >
              <template #default="scope">
                {{scope.row.state == 1?'未处理':scope.row.state == 2?'已处理':''}}
              </template>
            </el-table-column>
            <el-table-column property="remark" label="备注" v-if="checkColList.indexOf('备注') > -1" class-name="cursor"/>
          </el-table>
          <div style="display: flex; justify-content: space-between">
            <el-table
                :data="sumDataList"
                style="width: 60em; margin-top: 16px;"
                v-loading="listLoading"
                size="default"
                border
            >
              <el-table-column property="" label="汇总" width="80"></el-table-column>
              <el-table-column property="satisfactionNum" label="满意"></el-table-column>
              <el-table-column property="generalNum" label="一般"></el-table-column>
              <el-table-column property="dissatisfactionNum" label="不满意"></el-table-column>
            </el-table>
            <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getFormData, postFormData,imgPostFormData } from "@/api/api";
import {
  getEvaluationPageList,
  getEvaluationPageSummary,
  updateSmsOff,
  getSmsOff,
  updateEvaluationState,
  getSysListMenuTag
} from "@/api/url";
// import UserDialog from "./components/UserDialog";
import Dialog from "@/assets/js/dialog"
import BtnGroup from '../../components/BtnGroup'
import SearchComponents from "@/components/SearchComponents";
import Drawer from "@/assets/js/drawer";
import UserImgList from "@/components/imgList/UserImgList";
import unLock from "@/layout/components/unLock";
import DatePickerRange from "@/components/DatePickerRange";
import userInfoDialog from "@/components/User/userInfoDialog";
import PetListDialog from "@/views/user/components/PetListDialog";
import StockRemarkDialog from "@/views/stock/components/StockRemarkDialog";
import EvRemarkDialog from "@/views/visit/components/EvRemarkDialog";
import UpdatePhoneDialog from "@/views/visit/components/UpdatePhoneDialog";

export default {
  name: "VisitEvaluation",
  components: { BtnGroup, SearchComponents, unLock, DatePickerRange},
  data() {
    return {
      pageDataList: [],
      sumDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,
      batchLoading: false,

      shopIdArray: [
        {name: '不限', id: 0}
      ],
      shopIdArr:[],
      shopId: 0,

      satisfactionArray: [
        {label: '不限', value: -1},
        {label: '满意', value: 3},
        {label: '一般', value: 2},
        {label: '不满意', value: 1},
      ],
      satisfaction: -1,

      stateArray: [
        {label: '不限', value: -1},
        {label: '未处理', value: 1},
        {label: '已处理', value: 2}
      ],
      state: -1,

      typeArray: [
        {label: '不限', value: -1},
        {label: '预约短信', value: 1},
        {label: '消费短信', value: 2},
        {label: '邀请评价短信', value: 3},
      ],
      type: -1,

      visitStateArray: [
        {label: '不限', value: -1},
        {label: '未查看', value: 1},
        {label: '已查看', value: 2}
      ],
      visitState: -1,

      //时间
      startTime: '',
      endTime: '',
      isChecked: false,


      //刷新组
      colList: ['时间', '所属门店', '短信类型', '客户信息', '猫咪信息', '消费单号', '查看状态', '满意度', '处理状态', '备注'],
      checkColList: [],

      //搜索
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '主人', value : 2},
        {label : '宠物昵称', value : 3},
        {label : '主人ID', value : 4},
      ],
      searchType: 1,
      searchValue: '',
      limitState: false,

      upUserLoading: false,
      upPetLoading: false,

      buttonType: -1,

      idArray: [],

      uploadImgId: 0,

      operateState: JSON.parse(sessionStorage.getItem('operateState')),

      preBookOff: 0,
      consumeOff: 0,
      phones: '',

    }
  },
  methods: {

    userInfoDialog(id) {
      Dialog.open({
        title: '',
        component: userInfoDialog,
        data: {
          userId: id,
          width: '640px',
        },
        confirm: () => {
        }
      })
    },

    userImgList(row) {
      let _title = '';
      _title = '回访图片列表'
      Drawer.open({
        title: _title,
        component: UserImgList,
        data: {
          imgArray: row.visitImgList,
          id: row.id,
          width: 908,
          from: 4,
          hideBtn: (this.operateState & 2)  == 2 || row.recheckState == 5 || row.recheckState == 6
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },

    // 重置参数
    refreshParam() {
      this.isChecked = false;
      this.limitState = false;
      this.state = -1;
      this.satisfaction = -1;
      this.type = -1;
      this.visitState = -1;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    buttonTypeChange(state) {
      this.buttonType = state
      this.getPage()
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },


    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
          this.buttonType = -1
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['shopId'] = this.shopId;
      param['satisfaction'] = this.satisfaction;
      param['state'] = this.state;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['limitState'] = this.limitState?1:0;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['visitState'] = this.visitState;
      param['type'] = this.type;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getEvaluationPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
          this.getSumPage(param)
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    getSumPage(param) {
      getFormData(getEvaluationPageSummary, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          this.sumDataList = []
          let result = data['data'];
          this.sumDataList.push(result)
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      })
          .catch((response) => {
          })
    },

    batchUpdateState() {
      if(this.idArray.length == 0) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请先选择评价记录',
          type: 'warning'
        });
        return false
      }
      this.$confirm('确定批量已处理吗？').then(() => {
        this.batchLoading = true
        let param = {};
        param['idArr'] = this.idArray;
        postFormData(updateEvaluationState, param).then(data => {
          let {code, msg} = data;
          if (code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            this.getPage()
            this.getMenuTag()
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          this.batchLoading = false;
        }).catch(()=> {
          this.batchLoading = false;
        })
      })
    },


    // getMenuTag() {
    //   getFormData(getSysListMenuTag).then(data => {
    //     let list = data.data
    //     let tagList = []
    //     list.map(item => {
    //       if(item.tagNum > 0) {
    //         tagList.push(item.menuId)
    //       }
    //     })
    //     this.$store.commit('UPDATE_MENU_TAG_LIST', tagList)
    //   })
    // },

    getMenuTag() {
      getFormData(getSysListMenuTag).then(data => {
        let list = data.data
        let tagList = []
        list.map(item => {
          if(item.tagNum > 0) {
            tagList.push(item.menuId)
          }
        })
        let menuList = JSON.parse(localStorage.getItem('menuList'))
        menuList.map(item => {
          if(item.children && item.children.length > 0) {
            for(let i=0; i<item.children.length; i++) {
              if(tagList.indexOf(item.children[i].id) > -1) {
                tagList.push(item.id)
                break;
              }
            }
          }
        })
        this.$store.commit('UPDATE_MENU_TAG_LIST', tagList)
      })
    },


    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.id);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.id) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

      if(column.label == '猫咪信息') {
        let editable = true
        Dialog.open({
          title: '猫咪信息',
          component: PetListDialog,
          data: {
            userForm: row,
            petList: row.petList,
            editable: editable,
            width: '1100px',
            userId: row.userId,
          },
          close: () => {
            if(JSON.parse(sessionStorage.getItem('recordState'))) {
              this.getPage()
            }
            sessionStorage.removeItem('recordState')
          }
        })
      }

      //更新用户日志
      if (column.label == '备注') {
        let remarkForm = Object.assign({}, row);
        Dialog.open({
          title: '备注',
          component: EvRemarkDialog,
          data: {
            remarkForm: remarkForm,
            width: '500px'
          },
          close: () => {
            this.getPage()
          }
        })
      }

    },

    getSmsOffState() {
      getFormData(getSmsOff).then(data => {
          this.preBookOff = Number(data.data.preBookOff)
          this.consumeOff = Number(data.data.consumeOff)
          this.phones = data.data.phones
      })
    },

    offChange(type) {
      let param = {}
      param['type'] = type
      param['off'] = type == 1?this.preBookOff:this.consumeOff
      postFormData(updateSmsOff, param).then(data => {
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      })
    },

    updatePhone() {
      Dialog.open({
        title: '通知短信',
        component: UpdatePhoneDialog,
        data: {
          phones: this.phones,
          width: '500px'
        },
        confirm: () => {
          this.getSmsOffState()
        }
      })
    }



  },

  created() {
    this.getSmsOffState()
  },

  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })

    // let visibleShopList = JSON.parse(sessionStorage.getItem('visibleShopList'))
    let ownShopList = JSON.parse(sessionStorage.getItem('ownShopList'))
    this.shopIdArray = this.shopIdArray.concat(ownShopList)
    // this.shopId = this.shopIdArray[0].id
    this.getPage();

  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/

.item-img {
  width: 80px;
  height: 80px;
}
</style>
